import { createZustandStoresContext } from '../lib/zustand/createZustandStoresContext';
import * as stateCreators from './stateCreators';

export const { ZustandStoresProvider, useZustandStore, useZustandStoreContainer } = createZustandStoresContext({
  stateCreators,
  persistKeys: ['auth', 'language'],
});
